/**
 * Created by nicolas.looschen@pikobytes.de on 04.12.2023.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import i18nConfig from '../../next-i18next.config';

export const defaultLng = i18nConfig.i18n.defaultLocale;
export const fallbackLng = i18nConfig.i18n.defaultLocale;
export const languages = i18nConfig.i18n.locales;
export const defaultNS = 'translation';
export const cookieName = 'i18next';

export function getOptions(
    lng: string = fallbackLng,
    ns: string | Array<string> = defaultNS
) {
    return {
        // debug: true,
        load: 'currentOnly',
        supportedLngs: languages,
        fallbackLng: false,
        lng,
        fallbackNS: defaultNS,
        defaultNS,
        ns,
    } as const;
}

export function isLanguageSupported(
    lng: string
): lng is (typeof languages)[number] {
    return (languages as Readonly<Array<string>>).includes(lng);
}
